/**
 * Interceptor para medir tiempos de respuesta de APIs
 * Se conecta automáticamente con el performance monitor
 */

let performanceMonitorCallback = null;

/**
 * Registra el callback del monitor de performance
 * @param {Function} callback - Función para actualizar métricas (updateAPIResponseTime)
 */
export const registerPerformanceCallback = (callback) => {
  performanceMonitorCallback = callback;
};

/**
 * Wrapper para fetch que mide el tiempo de respuesta
 */
const originalFetch = global.fetch;

export const setupAPIPerformanceMonitoring = () => {
  if (!originalFetch) return;

  global.fetch = async (...args) => {
    const startTime = Date.now();
    
    // Extraer URL de diferentes formatos
    let url = 'unknown';
    try {
      if (typeof args[0] === 'string') {
        url = args[0];
      } else if (args[0] instanceof Request) {
        url = args[0].url;
      } else if (args[0]?.url) {
        url = args[0].url;
      } else if (args[0]?.uri) {
        url = args[0].uri;
      }
    } catch (e) {
      url = 'unknown';
    }
    
    try {
      const response = await originalFetch(...args);
      const endTime = Date.now();
      const duration = endTime - startTime;

      // Notificar al monitor con URL
      if (performanceMonitorCallback && typeof performanceMonitorCallback === 'function') {
        performanceMonitorCallback(duration, url);
      }

      // Log en desarrollo
      if (__DEV__) {
        const urlShort = url.length > 50 ? url.substring(0, 50) + '...' : url;
        console.log(`[API Performance] ${urlShort}: ${duration}ms`);
      }

      return response;
    } catch (error) {
      const endTime = Date.now();
      const duration = endTime - startTime;
      
      // También medir errores (pueden ser lentos)
      if (performanceMonitorCallback && typeof performanceMonitorCallback === 'function') {
        performanceMonitorCallback(duration, url);
      }

      throw error;
    }
  };
};

/**
 * Restaura el fetch original (útil para cleanup)
 */
export const restoreOriginalFetch = () => {
  if (originalFetch) {
    global.fetch = originalFetch;
  }
};

export default {
  registerPerformanceCallback,
  setupAPIPerformanceMonitoring,
  restoreOriginalFetch,
};
